module.exports = __webpack_public_path__ + "img/services.62b09c27.svg";